import { render } from "./afterSaleQuestion.vue?vue&type=template&id=7d4628b5&scoped=true"
import script from "./afterSaleQuestion.vue?vue&type=script&lang=js"
export * from "./afterSaleQuestion.vue?vue&type=script&lang=js"

import "./afterSaleQuestion.vue?vue&type=style&index=0&id=7d4628b5&lang=less&scoped=true"

import exportComponent from "D:\\work\\ask_cloud\\QC\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d4628b5"]])

export default __exports__